import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = {
  class: "tab-content p-15 p-sm-20 p-md-25 p-lg-30",
  id: "myTabContent"
}
const _hoisted_4 = {
  class: "tab-pane fade show active",
  id: "edit-user-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-12 mb-20" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "col-md-6 mb-20" }
const _hoisted_11 = { class: "col-md-6 mb-20" }
const _hoisted_12 = { class: "col-md-6 mb-20" }
const _hoisted_13 = { class: "col-md-6 mb-20" }
const _hoisted_14 = { class: "col-md-6 mb-20" }
const _hoisted_15 = { class: "col-md-6 mb-20" }
const _hoisted_16 = { class: "col-md-12 mb-20" }
const _hoisted_17 = { class: "col-md-12 mb-20" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "col-md-12 mb-20" }
const _hoisted_20 = { class: "col-md-6 mb-20" }
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "col-md-6 mb-20" }
const _hoisted_23 = { class: "col-md-6 mb-20" }
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "col-md-6 mb-20" }
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "col-md-4 mb-20" }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "col-md-4 mb-20" }
const _hoisted_30 = { class: "col-md-4 mb-20" }
const _hoisted_31 = { class: "col-md-12 d-flex align-items-center justify-content-between mt-20" }
const _hoisted_32 = {
  type: "submit",
  class: "btn btn-success px-4 py-2"
}
const _hoisted_33 = {
  key: 0,
  class: "spinner-border spinner-border-sm ms-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[39] || (_cache[39] = _createElementVNode("ul", {
        class: "nav nav-tabs bg-white border-0 rounded-0",
        id: "myTab",
        role: "tablist"
      }, [
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100 active",
            id: "edit-user-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#edit-user-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "edit-user-tab-pane",
            "aria-selected": "true"
          }, " Informations de l'utilisateur ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            onSubmit: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[20] || (_cache[20] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Photo de profil ", -1)),
                _createElementVNode("div", _hoisted_7, [
                  (_ctx.imagepreview)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.imagepreview,
                        class: "rounded-circle me-15",
                        style: {"width":"90px","height":"90px","object-fit":"cover"}
                      }, null, 8, _hoisted_8))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: require('@/assets/images/NoImage.png'),
                        class: "rounded-circle me-15",
                        style: {"width":"90px","height":"90px","object-fit":"cover"}
                      }, null, 8, _hoisted_9)),
                  _createElementVNode("div", null, [
                    _createElementVNode("input", {
                      ref: "updateImgInput",
                      type: "file",
                      accept: "image/*",
                      class: "d-none",
                      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logoSelected && _ctx.logoSelected(...args)))
                    }, null, 544),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary me-2",
                      onClick: _cache[1] || (_cache[1] = () => _ctx.updateImgInput?.click())
                    }, " Choisir la photo "),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-secondary",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelImage && _ctx.cancelImage(...args)))
                    }, " Annuler ")
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[21] || (_cache[21] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Nom complet *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userData.name) = $event)),
                  type: "text",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Nom complet",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.userData.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[22] || (_cache[22] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "CIN *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userData.cin) = $event)),
                  type: "text",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "CIN",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.userData.cin]
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[23] || (_cache[23] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Numéro de téléphone *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.userData.phone) = $event)),
                  type: "text",
                  pattern: "^0[0-9]{9}$",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "0XXXXXXXXX",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.userData.phone]
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[24] || (_cache[24] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Adresse électronique *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.userData.email) = $event)),
                  type: "email",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "exemple@email.com",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.userData.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _cache[25] || (_cache[25] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Mot de passe *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.userData.password) = $event)),
                  type: "password",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Mot de passe",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.userData.password]
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[26] || (_cache[26] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Confirmation de mot de passe *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.userData.c_password) = $event)),
                  type: "password",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Confirmer mot de passe",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.userData.c_password]
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _cache[27] || (_cache[27] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Ville utilisateur *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.userData.city_user) = $event)),
                  type: "text",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Ville utilisateur",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.userData.city_user]
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[28] || (_cache[28] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Ville *", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.userData.city_id) = $event)),
                  class: "form-select shadow-none rounded-0",
                  required: ""
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.citiesList, (c, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: i,
                      value: c.id
                    }, _toDisplayString(c.name), 9, _hoisted_18))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.userData.city_id]
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _cache[29] || (_cache[29] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Adresse *", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.userData.adresse) = $event)),
                  rows: "2",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Adresse complète",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.userData.adresse]
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[30] || (_cache[30] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Nom du banque *", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.userData.id_bank) = $event)),
                  class: "form-select shadow-none rounded-0",
                  required: ""
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bankList, (b, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: i,
                      value: b.id
                    }, _toDisplayString(b.name), 9, _hoisted_21))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.userData.id_bank]
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _cache[31] || (_cache[31] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Numéro du compte *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.userData.rib) = $event)),
                  type: "number",
                  class: "form-control shadow-none rounded-0",
                  minlength: "24",
                  maxlength: "24",
                  placeholder: "RIB",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.userData.rib]
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _cache[32] || (_cache[32] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Agence *", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.userData.agency) = $event)),
                  class: "form-select shadow-none rounded-0",
                  required: ""
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agencyList, (a, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: i,
                      value: a.id
                    }, _toDisplayString(a.name), 9, _hoisted_24))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.userData.agency]
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _cache[33] || (_cache[33] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Fonction *", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.userData.role_id) = $event)),
                  class: "form-select shadow-none rounded-0",
                  required: ""
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.functionsList, (f, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: i,
                      value: f.id
                    }, _toDisplayString(f.name), 9, _hoisted_26))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.userData.role_id]
                ])
              ]),
              (_ctx.userData?.role_id === 4)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_27, [
                      _cache[34] || (_cache[34] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Zone *", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.userData.zone_liv_id) = $event)),
                        class: "form-select shadow-none rounded-0"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.zoneList, (z, i) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: i,
                            value: z.id
                          }, _toDisplayString(z.name), 9, _hoisted_28))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.userData.zone_liv_id]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _cache[35] || (_cache[35] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Frais de livraison *", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.userData.livred_fees) = $event)),
                        type: "text",
                        class: "form-control shadow-none rounded-0",
                        placeholder: "Frais de livraison"
                      }, null, 512), [
                        [_vModelText, _ctx.userData.livred_fees]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _cache[36] || (_cache[36] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Frais de refus *", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.userData.refused_fees) = $event)),
                        type: "text",
                        class: "form-control shadow-none rounded-0",
                        placeholder: "Frais de refus"
                      }, null, 512), [
                        [_vModelText, _ctx.userData.refused_fees]
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("button", _hoisted_32, [
                  _cache[37] || (_cache[37] = _createTextVNode(" Enregistrer ", -1)),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_33))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_router_link, {
                  to: "/users-list",
                  class: "btn btn-link text-danger"
                }, {
                  default: _withCtx(() => _cache[38] || (_cache[38] = [
                    _createTextVNode(" Annuler ", -1)
                  ])),
                  _: 1,
                  __: [38]
                })
              ])
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}